<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" md="12">
        <component-header
          title="Edit Coupon"
          :hasSearch="false"
          :hasCreate="false"
          :hasReload="false"
          :hasback="true"
          @back-press="$router.push({ name: 'Coupon' })"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" md="12">
        <b-card>
          <form>
            <div>
              <b-row>
                <b-col cols="12" sm="12" md="4">
                  <label for="promoCode">Coupon Code</label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="promocode"
                  >
                    <b-form-input
                      id="promoCode"
                      class="w-75"
                      disabled
                      inputType="text"
                      v-model="inputObject.promoCode"
                    />
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col cols="12" sm="12" md="4">
                  <label for="categoryOptions">Applicable On</label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Applicable on"
                  >
                    <eb-select
                      class="myDIV w-75"
                      id="categoryOptions"
                      type="text"
                      label="label"
                      v-model="inputObject.applicableOn"
                      @input="categorySelected"
                      :options="categoryOptions"
                      :selected="inputObject.applicableOn"
                      placeholder="Select reward type"
                    ></eb-select>
                    <span class="hide"
                      ><b class="text-danger">Hint</b>: Select Applicable
                      On.</span
                    >
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col
                  cols="12"
                  sm="12"
                  md="4"
                  v-if="inputObject.applicableOn.value === 'CATALOG'"
                >
                  <label for="catalog-id">Catalog</label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Catalog"
                  >
                    <eb-select
                      id="catalog-id"
                      type="text"
                      class="w-75"
                      label="text"
                      :options="catalogList"
                      :selected="inputObject.catalogId"
                      @input="selectedcatalog"
                      placeholder="Select reward type"
                    ></eb-select>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col md="4" v-if="inputObject.applicableOn.value === 'ITEM'">
                  <b-row>
                    <b-col col="12">
                      <label for="item-catalog-id">Catalog</label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Catalog"
                      >
                        <eb-select
                          id="item-catalog-id"
                          type="text"
                          class="w-75"
                          label="text"
                          :options="catalogList"
                          :selected="inputObject.catalogId"
                          @input="itemCatalogSelected"
                          placeholder="Select Item catalog"
                        />
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                  <b-row
                    class="mt-3"
                    v-if="inputObject.catalogId && itemsList.length"
                  >
                    <b-col col="12">
                      <label for="item-id">Item</label>
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        name="Item"
                      >
                        <eb-select
                          id="item-id"
                          type="text"
                          class="w-75"
                          label="text"
                          :options="itemsList"
                          v-model="inputObject.itemId"
                          placeholder="Select Item"
                          value="value"
                        ></eb-select>
                        <span class="validate-error">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col
                  md="4"
                  v-if="
                    inputObject.applicableOn.value === 'PARTNER' &&
                    userRole === 'Tenant'
                  "
                >
                  <label for="selectSeller">Partner</label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Partner"
                  >
                    <eb-select
                      type="text"
                      class="w-75"
                      :id="'selectSeller'"
                      v-model="currentProvider"
                      :options="partnerList"
                      label="text"
                      placeholder="Select Partner"
                      :selected="currentProvider"
                      @input="changeSeller"
                    ></eb-select>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label for="title">Title:</label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="title"
                  >
                    <br />
                    <textarea
                      rows="2"
                      cols="30"
                      class="border border-dark myDIV"
                      id="title"
                      inputType="text"
                      maxlength="100"
                      v-model="inputObject.title"
                    />
                    <span class="hide">
                      <b class="text-danger">Hint</b>: Insert "Title" like
                      COUPON2021, NEWYEAROFFER.</span
                    >
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col md="4">
                  <label for="description" class="font-weight-bold d-block mb-1">Description</label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="description"
                  >
                    <textarea
                      rows="4"
                      cols="30"
                      class="border border-dark myDIV"
                      id="description"
                      inputType="text"
                      maxlength="300"
                      v-model="inputObject.description"
                    />
                    <span class="hide"
                      ><b class="text-danger">Hint</b>: Get a reward of Rs.100
                      off on purchase of Rs.600 with an attached this
                      coupon.</span
                    >
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label for="startdate">Start Date</label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="startdate"
                  >
                    <b-input
                      class="myDIV w-75"
                      id="startdate"
                      type="date"
                      v-model="inputObject.startDate"
                    ></b-input>
                    <span class="hide">
                      <b class="text-danger">Hint</b>: Select start date from
                      calendar dropdown.</span
                    >
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col md="4">
                  <label for="enddate">End Date:</label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="enddate"
                  >
                    <b-input
                      class="myDIV w-75"
                      id="enddate"
                      type="date"
                      v-model="inputObject.endDate"
                    ></b-input>
                    <span class="hide">
                      <b class="text-danger">Hint</b>: Select End date from
                      calendar dropdown.</span
                    >
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col md="4">
                  <label for="maxRewardValue">Max Reward Value</label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="maxRewardValue"
                  >
                    <b-form-input
                      class="myDIV w-75"
                      id="maxRewardValue"
                      inputType="text"
                      maxlength="100"
                      v-model="inputObject.maxRewardValue"
                    />
                    <span class="hide"
                      ><b class="text-danger">Hint</b>: Enter maximum reward
                      value like 50,100.</span
                    >
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4">
                  <label for="minimumAmountExcludingTax"
                    >MinimumAmount Excluding Tax</label
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="minimumAmountExcludingTax"
                  >
                    <b-form-input
                      class="myDIV w-75"
                      id="minimumAmountExcludingTax"
                      inputType="text"
                      maxlength="100"
                      v-model="inputObject.minimumAmountExcludingTax"
                    />
                    <span class="hide"
                      ><b class="text-danger">Hint</b>: Minimum value required to
                      apply Coupon Code.</span
                    >
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col md="4">
                  <label for="rewardValue">Reward Value</label>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="rewardValue"
                  >
                    <b-input
                      class="myDIV w-75"
                      id="rewardValue"
                      type="text"
                      v-model="inputObject.rewardValue"
                    ></b-input>
                    <span class="hide"
                      ><b class="text-danger">Hint</b>: Reward Value should be
                      less or equal to Maximum Reward Value.</span
                    >
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </b-col>
                <b-col md="4">
                  <label for="rewardType">Reward Type</label>
                  <eb-select
                    class="myDIV w-75"
                    id="rewardType"
                    type="text"
                    label="label"
                    v-model="inputObject.rewardType"
                    @input="selectrewardtype"
                    :options="rewardType"
                    :selected="inputObject.rewardType"
                    placeholder="Select reward type"
                  ></eb-select>
                  <span class="hide"
                    ><b style="color: red">Hint</b>: Reward Type should be
                    Discount.</span
                  >
                </b-col>
              </b-row>
              <div>
                <b-row>
                  <b-col md="4">
                    <label for="discountType">Discount Type</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="discountType"
                    >
                      <eb-select
                         class="myDIV w-75"
                        id="discountType"
                        type="text"
                        label="label"
                        v-model="inputObject.discountType"
                        @input="discountSelected"
                        :selected="inputObject.discountType"
                        :options="discountType"
                        placeholder="Select discount type"
                      ></eb-select>
                      <span class="hide"
                        ><b class="text-danger">Hint</b>: Select “Number” from
                        Discount Type dropdown.</span
                      >
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                  <b-col md="4">
                    <label for="within">Frequency in minutes</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Timing Rules"
                    >
                      <b-form-input
                         class="myDIV w-75"
                        inputType="text"
                        v-model="timingRules.within"
                      />
                      <span class="hide">
                        <b class="text-danger">Hint</b>: Number of times to apply
                        coupon code per minute by Customer like 5, 7 etc.</span
                      >
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                  <b-col md="4">
                    <label for="totalLimit">Total allowed in day</label>
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Timing Rules"
                    >
                      <b-form-input
                         class="myDIV w-75"
                        id="totalLimit"
                        inputType="text"
                        v-model="timingRules.totalLimit"
                      />
                      <span class="hide"
                        ><b class="text-danger">Hint</b>: Number of times coupon
                        code can be used by customer per day likes 5 or 10
                        times.</span
                      >
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                  <b-col md="4">
                    <label for="maxExisting"
                      >Max Existing Orders
                      <i
                        placement="topright"
                        id="maxExisting"
                        class="fas fa-question-circle text-primary"
                        ><b-tooltip
                          target="maxExisting"
                          placement="topright"
                          triggers="hover"
                          >Coupon will work only for people having existing
                          orders less than specified number</b-tooltip
                        ></i
                      ></label
                    >

                    <b-form-input
                      id="maxExisting"
                      class="w-75"
                      inputType="text"
                      v-model="inputObject.maxExistingOrders"
                    />
                  </b-col>
                  <b-col md="4">
                    <label for="minExiting"
                      >Min Existing Orders
                      <i
                        placement="topright"
                        id="minExiting"
                        class="fas fa-question-circle text-primary"
                        ><b-tooltip
                          target="minExiting"
                          placement="topright"
                          triggers="hover"
                          >Coupon will be available only for those who have this
                          much existing orders.</b-tooltip
                        ></i
                      ></label
                    >

                    <b-form-input
                      id="minExiting"
                      class="w-75"
                      inputType="text"
                      v-model="inputObject.minExistingOrders"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="4" class="pr-0" v-for="(tc, idx) in tc" :key="idx">
                    <label for="tc">Terms and Conditions</label>
                    <br />
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Terms and Conditions"
                    >
                      <textarea
                        id="tc"
                        rows="4"
                        cols="30"
                        class="border border-dark myDIV"
                        inputType="text"
                        v-model="tc.tc"
                      ></textarea>
                      <span class="hide">
                        <b class="text-danger">Hint</b>: Terms and Conditions
                        like 1) This is valid on purchase more than amount 200
                        2) This is valid for valid period. 3) This is used only
                        no of times per day.
                      </span>
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
              </div>
              <b-row>
                <b-col md="4">
                  <b-form-checkbox switch v-model="allowMultiDiscount"
                    >Allow MultiDiscount</b-form-checkbox
                  >
                </b-col>
                <b-col md="4">
                  <b-form-checkbox switch v-model="promote"
                    >Promote</b-form-checkbox
                  >
                </b-col>
                <b-col md="4">
                  <b-form-checkbox switch v-model="autoApply"
                    >AutoApply</b-form-checkbox
                  >
                </b-col>
              </b-row>
            </div>
            <b-row>
              <b-col md="12">
                <div class="text-center mb-5 p-4">
                 <button
                     type="button"
                     class="text-uppercase btn btn-lg btn-danger mr-3 w-15"
                     @click="$router.push({ name: 'Coupon' })"
                      >
                      Cancel
                     </button>
                   <button
                    type="button"
                    class="text-uppercase btn btn-lg btn-primary ml-3 w-15"
                    @click="handleSubmit"
                  >
                    Update
                  </button>
                </div>
              </b-col>
            </b-row>
          </form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.esm";
import cInput from "@/components/Common/CustomInput";
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import CouponDetails from "@/components/MasterSetup/Coupon/CouponDetails";
import { mapGetters, mapActions } from "vuex";
import ComponentHeader from "@/components/componentNewHeader";
export default {
  name: "editcoupon",
  components: {
    ebButton,
    cInput,
    CouponDetails,
    ValidationProvider,
    ValidationObserver,
    ebSelect,
    ComponentHeader,
  },
  data: () => {
    return {
      show: true,
      currentProvider: "",
      allowMultiDiscount: false,
      promote: false,
      autoApply: true,
      timingRules: [
        {
          within: "",
          totalLimit: "",
        },
      ],
      inputObject: {
        rewardType: "",
        title: "",
        rewardValue: "",
        description: "",
        catalogId: "",
        maxRewardValue: "",
        minimumAmountExcludingTax: "",
        applicableOn: {},
        discountType: "",
        itemId: "",
        tags: [],
        startDate: "",
        endDate: "",
        promoCode: "",
        maxExistingOrders: null,
        minExistingOrders: null,
      },
      tc: [
        {
          tc: "",
          isRemovable: false,
          text: "Add",
        },
      ],
      catalogList: [],
      rewardType: [
        {
          label: "Discount",
          value: "Discount",
        },
        {
          label: "Shipping",
          value: "Shipping",
        },
        {
          label: "Wallet",
          value: "Wallet",
        },
      ],
      discountType: [
        {
          label: "Number",
          value: "Number",
        },
        {
          label: "Percentage",
          value: "Percentage",
        },
      ],
      itemsList: [],
    };
  },
  mounted() {
    this.details = { ...this.$route.params.data };
    this.getCatalogName();
    this.Getpartnerlist();
    this.inputObject.promoCode = this.details.promoCode;
    this.inputObject.rewardType = this.details.promoRules.rewardType;
    this.inputObject.title = this.details.title;
    this.inputObject.rewardValue = this.details.promoRules.rewardValue;
    this.inputObject.description = this.details.description;
    this.inputObject.catalogId = this.details.promoRules.catalogId;
    this.inputObject.maxRewardValue = this.details.promoRules.maxRewardValue;
    this.inputObject.minimumAmountExcludingTax =
      this.details.promoRules.minimumAmountExcludingTax;
    this.inputObject.applicableOn = this.categoryOptions.find(
      (c) => c.value === this.details.promoRules.applicableOn
    );
    this.inputObject.discountType = this.details.promoRules.discountType;
    this.tc = this.details.tc.map((t, i) => {
      return {
        tc: t,
        isRemovable: i !== 0,
        text: i !== 0 ? "Remove" : "Add",
      };
    });
    this.inputObject.startDate = this.details.promoRules.startDate.slice(0, 10);
    this.inputObject.endDate = this.details.promoRules.endDate.slice(0, 10);
    this.inputObject.tags = this.details.tags;
    this.timingRules.within = this.details.timingRules.within;
    this.timingRules.totalLimit = this.details.timingRules.totalLimit;
    this.allowMultiDiscount = this.details.allowMultiDiscount;
    this.promote = this.details.promote;
    this.autoApply = this.details.autoApply;
  },
  computed: {
    ...mapGetters({
      provider: "auth/getUserID",
    }),
    categoryOptions() {
      if (
        this.$currentUserData &&
        this.$currentUserData.category !== "SELLER"
      ) {
        return [
          {
            label: "Catalog",
            value: "CATALOG",
          },
          {
            label: "Partner",
            value: "PARTNER",
          },
          {
            label: "Item",
            value: "ITEM",
          },
          {
            label: "Order",
            value: "ORDER",
          },
          {
            label: "Registration",
            value: "REGISTRATION",
          },
          {
            label: "Referral",
            value: "REFERRAL",
          },
        ];
      } else {
        return [
          {
            label: "Catalog",
            value: "CATALOG",
          },
          {
            label: "Item",
            value: "ITEM",
          },
          {
            label: "Order",
            value: "ORDER",
          },
        ];
      }
    },
    partnerList() {
      let data = this.$store.getters["partner/GetPartnerList"];
      let partnerList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          partnerList.push({
            text: obj.authentication.userName,
            value: obj._id,
          });
        });
        return partnerList;
      } else {
        return [];
      }
    },
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
  },
  methods: {
    ...mapActions({
      Getpartnerlist: "partner/officeList",
    }),
    categorySelected(event) {
      this.inputObject.applicableOn = event;
    },
    selectedcatalog(event) {
      this.inputObject.catalogId = event;
    },
    discountSelected(event) {
      this.inputObject.discountType = event;
    },
    selectrewardtype(event) {
      this.inputObject.rewardType = event;
    },
    changeSeller(event) {
      this.inputObject.provider = this.currentProvider
        ? this.currentProvider._id
        : null;
    },
    async onClicktcButton(item, idx) {
      const { isRemovable } = item;
      if (!isRemovable)
        this.tc.push({
          tc: "",
          isRemovable: true,
          text: "Remove",
        });
      else this.tc.splice(idx, 1);
    },
    async handleSubmit() {
      let dataObj;
      dataObj = {
        promoCode: this.inputObject.promoCode,
        description: this.inputObject.description,
        title: this.inputObject.title,
        promoRules: {
          startDate: this.inputObject.startDate,
          endDate: this.inputObject.endDate,
          maxRewardValue: this.inputObject.maxRewardValue,
          minimumAmountExcludingTax: this.inputObject.minimumAmountExcludingTax,
          rewardValue: this.inputObject.rewardValue,
          discountType: this.inputObject.discountType.value,
          rewardType: this.inputObject.rewardType.value,
          applicableOn: this.inputObject.applicableOn.value,
          maxExistingOrders: this.inputObject.maxExistingOrders,
          minExistingOrders: this.inputObject.minExistingOrders,
        },
        timingRules: {
          within: this.timingRules.within,
          totalLimit: this.timingRules.totalLimit,
        },
        tc: this.tc.map((t) => t.tc),
        tags: [],
        autoApply: this.autoApply,
        allowMultiDiscount: this.allowMultiDiscount,
        promote: this.promote,
      };
      if (
        this.$currentUserData &&
        this.$currentUserData.category === "SELLER"
      ) {
        dataObj.promoRules["applicableOn"] = "PARTNER";
      }
      switch (this.inputObject.applicableOn.value) {
        case "ITEM":
          dataObj.promoRules.itemId = this.inputObject.itemId.value;
          break;
        case "CATALOG":
          dataObj.promoRules.catalogId = this.inputObject.catalogId.value;
          break;
        case "PARTNER":
          if (this.userRole === "Tenant") {
            dataObj.promoRules.providerId = this.currentProvider
              ? this.currentProvider.value
              : "";
          }
      }
      await this.$store
        .dispatch("coupon/editCouponcode", dataObj)
        .then(() => {
          this.$swal({
            title: "Success",
            text: "Coupon Updated successfully!!",
            type: "success",
          });
          this.$router.push({ name: "Coupon" });
        })
        .catch((error) =>
          this.$toasted.error(
            error.message ? error.message : "Failed to update"
          )
        );
    },
    async getCatalogName() {
      if (this.userRole === "Tenant") {
        await this.$store.dispatch("catalog/fetchTenantCatalogTree");
        const result = await this.$store.getters[
          "catalog/GetTenantCatalogTree"
        ];
        this.catalogList = result
          .filter((Obj) => Obj.isProductType)
          .map((c) => ({ text: c.name, value: c._id }));
        this.catalogList.reverse();
        this.isloader = false;
      } else {
        await this.$store.dispatch("catalog/fetchPartnerCatalogTree");
        const result = await this.$store.getters[
          "catalog/GetPartnerCatalogTree"
        ];
        this.catalogList = result
          .filter((Obj) => Obj.isProductType)
          .map((c) => ({ text: c.name, value: c._id }));
        this.catalogList.reverse();
        this.isloader = false;
      }
    },
    async itemCatalogSelected(event) {
      this.inputObject.catalogId = event;
      this.itemsList = [];
      let condition = {
        catalogId: event.value,
      };
      if (this.userRole !== "Tenant") {
        condition.provider = this.$store.getters["auth/getUserID"];
      }
      const data = await this.$store.dispatch(
        "item/fetchItemsByCatalog",
        condition
      );
      const list = [];
      data.response.forEach((d) => {
        const name = d.string_attributes.find(
          (x) => x.attribute_name === "Name"
        );
        if (name) {
          list.push({
            text: name.attribute_value,
            value: d._id,
          });
        }
      });
      this.itemsList = list;
    },
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}
.myDIV:hover + .hide {
  display: block;
  position: relative;
  margin-top: 4px;
}
.hide {
  display: none;
  font-size: 11px;
}
</style>
